export default __webpack_public_path__ + "static/media/copyright.fac28dfb.svg";